import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { connect } from "react-redux";
import { replace, go } from "react-router-redux";
import { getLatestMessage } from "redux-flash";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";
import Snackbar from "material-ui/Snackbar";
import AccountCircle from "material-ui-icons/AccountCircle";
import Menu, { MenuItem } from "material-ui/Menu";
import BottomNavigation, {
  BottomNavigationAction,
} from "material-ui/BottomNavigation";
import HelpIcon from "material-ui-icons/Help";
import PlaylistPlayIcon from "material-ui-icons/PlaylistPlay";
import TodayIcon from "material-ui-icons/Today";
import PersonIcon from "material-ui-icons/Person";
import CollectionsIcon from "@material-ui/icons/Collections";
import classNames from "classnames";
import Loading from "../utils/loading/Loading";
import Retry from "../utils/retry/Retry";
import UserAuthenticated from "../utils/auth/UserAuthenticated";
import { getUserRequest } from "./actions";
import { logoutRequest } from "../login/actions";
import styles from "./Admin.scss";
import RootRef from "@material-ui/core/RootRef";
import Welcome from "./Welcome";

const bottomNavigationItems = [
  {
    label: "Mes listes",
    icon: <PlaylistPlayIcon />,
    path: "/playlists",
  },
  {
    label: "Planifications",
    icon: <TodayIcon />,
    path: "/plannings",
  },
  // {
  //   label: 'Quiz',
  //   icon: <HelpIcon />,
  //   path: '/quiz',
  // },
  {
    label: "Mon Profil",
    icon: <PersonIcon />,
    path: "/updateprofile",
  },
  // {
  //   label: 'Flyers',
  //   icon: <CollectionsIcon />,
  //   path: '/flyers'
  // },
];

class Admin extends Component {
  static propTypes = {
    route: PropTypes.objectOf(PropTypes.any).isRequired,
    admin: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }),
      subcription: PropTypes.shape({
        accountStatus: PropTypes.shape({
          isTrialExpired: PropTypes.bool,
          isCardAdded: PropTypes.bool,
          isSubscriptionExpired: PropTypes.bool,
          remaningTrialDays: PropTypes.number,
          stripeCurrentPeriodEnd: PropTypes.string,
          isSubscribed: PropTypes.bool,
        }),
      }),
    }).isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    getUserRequest: PropTypes.func.isRequired,
    logoutRequest: PropTypes.func.isRequired,
    navigateTo: PropTypes.func.isRequired,
    snackbarMessage: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super(props);
    this.bottomBarDomElem = React.createRef();
    this.state = {
      anchorEl: null,
      selectedItemIndex: this.getselectedItemIndex(props),
      isSubscribe: true,
    };
  }
  getElem = () => {
    return this.bottomBarDomElem;
  };
  componentDidMount() {
    this.getUser();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      ...this.state,
      selectedItemIndex: this.getselectedItemIndex(nextProps),
    });
  }

  getUser = () => {
    console.log("getuser called");
    const { id, userId } = this.props.login.authData;
    this.props.getUserRequest({ id, userId });
  };

  getselectedItemIndex = (props) => {
    const { location } = props;
    return bottomNavigationItems.findIndex(({ path }) =>
      location.pathname.startsWith(path)
    );
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLogout = () => {
    this.props.logoutRequest();

    this.handleClose();
  };

  handleRetry = () => {
    this.getUser();
  };

  handleBottomNavigationChange = (_, value) => {
    const { path } = bottomNavigationItems[value];
    this.props.navigateTo(path);
  };

  componentDidUpdate() {
    if (
      this.props.admin &&
      (this.props.admin.user || this.props.admin.previousUser)
    ) {
      // Current or previous user i case of unavailable current user (get error)
      const cachedUser = this.props.admin.user || this.props.admin.previousUser;

      // Refresh user status
      if (
        cachedUser &&
        cachedUser.videoGenerateStatus &&
        cachedUser.videoGenerateStatus == "pending"
      ) {
        console.log("still pending", cachedUser.videoGenerateStatus);
        clearTimeout(this.getUserTimeout);
        this.getUserTimeout = setTimeout(this.getUser, 5000);
      }
    }
  }

  render() {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const {
      admin: { requesting, successful, error, user, previousUser, subcription },
      snackbarMessage,
    } = this.props;

    // Store either the current version or the previous version of the user, so that we always have a copy of the user values
    // This is needed as the user gets cleaned from the store before a new request to the user is made
    // By having the previous user copy, we can always render components based on the user, even while refreshing its data
    const cachedUser = user || previousUser;
    const welcomeLastStepReached = localStorage.getItem(
      "WELCOME_LAST_STEP_REACHED"
    )
      ? JSON.parse(localStorage.getItem("WELCOME_LAST_STEP_REACHED"))
      : false;
    //console.log("welcome", this.props.admin.user)

    // fix for admin
    if (
      typeof cachedUser !== "undefined" &&
      (!cachedUser.videoGenerateStatus ||
        window.location.href.includes("#skip"))
    ) {
      cachedUser.videoGenerateStatus = "completed";
      if (user) {
        user.videoGenerateStatus = "completed";
      }
    }

    return (
      <Fragment>
        {typeof cachedUser == "undefined" && requesting && (
          <Loading size={80} />
        )}

        {cachedUser &&
          (!welcomeLastStepReached ||
            cachedUser.videoGenerateStatus == "pending") && (
            <Welcome user={cachedUser} />
          )}

        {successful &&
          typeof user !== "undefined" &&
          !(
            cachedUser &&
            (!welcomeLastStepReached ||
              cachedUser.videoGenerateStatus == "pending")
          ) && (
            /*{successful && typeof user !== "undefined" && user.videoGenerateStatus == "completed" && (*/

            <Fragment>
              <AppBar position="fixed">
                {!subcription.accountStatus.isCardAdded &&
                  subcription.accountStatus.remaningTrialDays <= 15 &&
                  !subcription.accountStatus.isSubscribed && (
                    <section className={styles.alert}>
                      <span>Votre offre gratuite</span>
                      {!subcription.accountStatus.remaningTrialDays <= 0 && (
                        <span> expire bientôt.</span>
                      )}
                      {subcription.accountStatus.remaningTrialDays <= 0 && (
                        <span> a expiré</span>
                      )}
                      &nbsp;
                      <Link
                        to="/subscriber"
                        replace
                        className={styles.linkStyle}
                      >
                        Abonnez-vous
                      </Link>
                    </section>
                  )}
                <Toolbar style={{ background: "#2196F3" }}>
                  <Typography
                    type="title"
                    className={classNames({
                      [styles.flex]: true,
                      [styles.white]: true,
                    })}
                  >
                    <Link to="/playlists" replace>
                      <b>Digidocteur</b>{" "}
                      <span className={styles.headerDescription}>
                        {" "}
                        - Gérez vos listes de lecture et leur diffusion au sein
                        de votre cabinet
                      </span>
                    </Link>
                  </Typography>
                  <div>
                    <Button
                      aria-owns={open ? "menu-appbar" : null}
                      aria-haspopup="true"
                      onClick={this.handleMenu}
                      className={styles.white}
                    >
                      <span className={styles.username}>
                        {" "}
                        {user.multiDoctor
                          ? user.multiDoctorNames
                          : `${user.firstName} ${user.lastName}`}
                      </span>{" "}
                      <AccountCircle />
                    </Button>
                    <Menu
                      id="menu-appbar"
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={open}
                      onClose={this.handleClose}
                    >
                      <MenuItem to="/subscriber">
                        <a href="/subscriber"> Abonnement</a>
                      </MenuItem>
                      {/* <MenuItem to="/updateprofile">
                      <a href="/updateprofile"> Mon profil</a>
                    </MenuItem> */}
                      <MenuItem to="/invoices">
                        <a href="/invoices"> Mes factures</a>
                      </MenuItem>
                      <MenuItem onClick={this.handleLogout}>
                        Déconnexion
                      </MenuItem>
                    </Menu>
                  </div>
                </Toolbar>
              </AppBar>

              <div className={styles.content}>
                {renderRoutes(this.props.route.routes, {
                  getBottomBarElem: this.getElem,
                })}
              </div>
              {/* <div ref={this.bottomBarDomElem}> */}
              <RootRef rootRef={this.bottomBarDomElem}>
                <BottomNavigation
                  onChange={this.handleBottomNavigationChange}
                  showLabels
                  value={this.state.selectedItemIndex}
                  className={styles.bottomNavigation}
                >
                  {bottomNavigationItems.map(({ label, icon }) => (
                    <BottomNavigationAction
                      className={styles.bottomNavigationAction}
                      label={label}
                      icon={icon}
                      key={label}
                    />
                  ))}
                </BottomNavigation>
              </RootRef>
              {/* </div> */}
            </Fragment>
          )}
        {error && <Retry message={error} onRetry={this.handleRetry} />}
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={typeof snackbarMessage.message !== "undefined"}
          snackbarcontentprops={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{snackbarMessage.message}</span>}
          className={styles.snackbar}
        />
        <style
          dangerouslySetInnerHTML={{
            __html: `
            body{
              margin: 0;
              background-color: #fff;
            }`,
          }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  admin: state.admin,
  login: state.login,
  snackbarMessage: getLatestMessage(state) || {},
});

const ConnectedAdmin = connect(mapStateToProps, {
  getUserRequest,
  logoutRequest,
  navigateTo: replace,
  popHistory: go,
})(Admin);

export default UserAuthenticated(ConnectedAdmin);



// WEBPACK FOOTER //
// ./src/pages/admin/Admin.jsx